import DomLayer from './dom/backgroundLayer.js';
import WebGLLayer from './webgl/backgroundLayer.js';

class BackgroundLayer {
    constructor(domElement, rootObject) {
        this._domLayer = new DomLayer(domElement);
        this._webglLayer = new WebGLLayer(rootObject);
        this._opacity = 1;
    }

    get opacity() { return this._opacity; }

    set opacity(value) {
        this._opacity = value;
        this._domLayer.opacity = value;
        this._webglLayer.opacity = value;
    }

    setBackground({
        type = 'none',
        color1 = null,
        color2 = null,
        gradientEnabled = false,
        gradientType = 'horizontal',
        image = null,
        imageOffsetX = 0,
        imageOffsetY = 0,
        imageScaleX = 1,
        imageScaleY = 1,
        texture = null,
        fitMode = 'cover',
    }) {
        this._domLayer.setBackground({
            type,
            color1,
            color2,
            gradientEnabled,
            gradientType,
            image,
            imageOffsetX,
            imageOffsetY,
            imageScaleX,
            imageScaleY,
            fitMode,
        });

        this._webglLayer.setBackground({ type, texture });
    }

    setRenderOrder(order) {
        this._domLayer.setRenderOrder(order);
        this._webglLayer.setRenderOrder(order);
    }

    updateSize() { this._domLayer.updateSize(); }
    update() { this._domLayer.update(); }
}

export default BackgroundLayer;
export { BackgroundLayer };
